import { default as OctecAppLogo } from "./new-images/octec-logo.svg";

export { ReactComponent as CallLogs } from './callLog.svg';
export { ReactComponent as CallLogCount } from './callLogCount.svg';
export { ReactComponent as NewChat } from './newchat-new.svg';
export { ReactComponent as NewGroup } from '../images/new-images/newgroup.svg';
export { ReactComponent as DotMenu } from './optionmenu-new.svg';
export { ReactComponent as Settings } from '../images/new-images/Frame (1).svg';
export { ReactComponent as ChatMute } from './chatMute.svg';
export { ReactComponent as ChatMuteOff } from './chatmute-off.svg';
export { ReactComponent as IconMeetingVideo } from './meeting-link-video.svg';
export { ReactComponent as IconMissedCallAudio } from './missedCallAudio.svg';
export { ReactComponent as IconMissedCallVideo } from './missedCallVideo.svg';
export { ReactComponent as BroadcastIcon } from './broadcast-icon.svg';
export { default as Banner } from './login-bg.png';
export { ReactComponent as LoginInfo } from './logininfo.svg';
export { default as loader } from './loader.svg';
export { default as ImgLoaderWhite } from './loader-white.svg';
export { default as ImgFavicon } from './favicon.png';
export { default as MeetingLinkIcon } from './Video call 1.svg';
export { default as logo } from '../images/new-images/DazApp.svg';
export { default as NewLogo } from '../images/new-images/DazApp.svg';
export { default as NewLogoSm } from '../images/new-images/DazApp.svg';
export { default as NewLogoVector } from "./new-images/DazApp.svg";
export { default as ScanQRLogo } from "../images/new-images/appicon.svg";
export { ReactComponent as RejectCall } from './rejectCall.svg';
export { ReactComponent as AudioOn } from './webcall/audio-on.svg';
export { ReactComponent as AudioOff } from './webcall/audio-mute.svg';
export { ReactComponent as VideoOn } from './webcall/video-on.svg';
export { ReactComponent as VideoOff } from './webcall/video-off.svg';
export { ReactComponent as AttenCall } from './webcall/attenCall.svg';
export { ReactComponent as BackToChat } from './webcall/backToChat.svg';
export { ReactComponent as Avatar } from './sample-profile.svg';
export { ReactComponent as Chat } from './new-images/chart.svg';
export { ReactComponent as Call } from './new-images/call.svg';
export { ReactComponent as UnsavedContact } from './call.svg';
export { ReactComponent as Video } from './new-images/video.svg';
export { ReactComponent as ArrowBack } from './arrowback.svg';
export { default as loaderSVG, default as loaderGIF } from './loader.svg';
export { ReactComponent as MailIcon } from './mailicon.svg';
export { ReactComponent as MailiconSolid } from './mailiconSolid.svg';
export { ReactComponent as EmptyContact } from './new-images/start-chart.svg';
export { ReactComponent as Search } from './search.svg';
export { ReactComponent as Close } from './search_close.svg';
export { ReactComponent as Logout } from '../images/new-images/logout.svg';
export { ReactComponent as Tick } from './Tick.svg';
export { ReactComponent as RecordAudio } from './record-mic.svg';
export { ReactComponent as StartRecord } from './startRecord.svg';
export { ReactComponent as StopRecord } from './stopRecord.svg';
export { default as broadcast } from './broadcast.png';
export { default as Loader, ReactComponent as IconLoader } from './loader.svg';
export { default as GroupChatAvatarImg } from './sample-group-profile.svg';
export { default as SingleChatAvatarImg } from './sample-callee-profile.png';
export { ReactComponent as ClosePopup } from './close.svg';
export { ReactComponent as FloatingCallVideo } from './floating-call-1.svg';
export { ReactComponent as FloatingCallAudio } from './floating-call-2.svg';
export { ReactComponent as FloatingCallAction } from './floating-call-action.svg';
export { ReactComponent as FloatingCallActionSm } from './floating-call-action-sm.svg';
export { ReactComponent as CallLogs2 } from './callLog2.svg';
export { ReactComponent as CloseWhite } from './close-white.svg';
export { ReactComponent as Retake } from './retake.svg';
export { ReactComponent as CameraIcon } from './cameraicon.svg';
export { ReactComponent as Menu } from './arrowdown.svg';
export { ReactComponent as DropdownArrow } from './arrowdown-Dark.svg';
export { ReactComponent as DropdownArrow2 } from './arrowdown-2.svg';
export { ReactComponent as Close2 } from './close2.svg';
export { ReactComponent as Info } from './errorinfo.svg';
export { ReactComponent as Tick2 } from './tick2.svg';
export { ReactComponent as AddParticiapants } from './addParticiapants.svg';
export { ReactComponent as Blocked } from './blocked.svg';
export { ReactComponent as Delete } from './delete.svg';
export { ReactComponent as Done } from './done.svg';
export { ReactComponent as Edit } from '../images/new-images/Frame.svg';
export { ReactComponent as GoBack } from './goback.svg';
export { default as mediaAudio } from './media-audio.svg';
export { default as mediaFile } from './media-document.svg';
export { default as mediaimg1 } from './media-img-1.png';
export { default as mediaimg2 } from './media-img-2.png';
export { default as mediaimg3 } from './media-img-3.png';
export { default as mediaVideo } from './media-video.svg';
export { ReactComponent as Status } from './status.svg';
export { ReactComponent as UnBlock } from './unBlock.svg';
export { ReactComponent as Next } from './next.svg';
export { ReactComponent as BlockedIcon } from './blocked-white.svg';
export { default as AudioRecord } from './audio-record.png';
export { default as AudioFile } from './dazaudio.png';
export { ReactComponent as ZoomIn } from './zoom-in.svg';
export { ReactComponent as ZoomOut } from './zoom-out.svg';
export { ReactComponent as ZoomRestore } from './zoom-restore.svg';
export { default as Document } from './doc-thumb.png';
export { ReactComponent as Attachment } from './attachments.svg';
export { ReactComponent as SendMessage } from './sendMessage.svg';
export { ReactComponent as ChatAudioReceiver } from './audio_record.svg';
export { ReactComponent as ChatAudioSender } from './chataudio.svg';
export { ReactComponent as ChatAudioReceiver2 } from './audio-file.svg';
export { ReactComponent as ChatAudioSender2 } from './audio-file.svg';
export { default as audioFileImg } from './audio-file-white.svg';
export { ReactComponent as ChatAudioRecorder, default as audioRecordImg } from './recorder.svg';
export { ReactComponent as ChatAudioRecorderDark } from './recorder-dark.svg';
export { ReactComponent as Audio2 } from './recentAudio.svg';
export { ReactComponent as ChatContact } from './chatcontact.svg';
export { ReactComponent as ChatContactRecei } from './chatcontactrecei.svg';
export { ReactComponent as ContactDetails } from './contactDetails.svg';
export { default as ChatContactImg } from './avatar.png';
export { ReactComponent as DocumentReceiver } from './doc.svg';
export { ReactComponent as DocumentSender } from './docrecei.svg';
export { ReactComponent as DocumentDownload } from './download-doc.svg';
export { ReactComponent as DocumentDownloadDark } from './download-doc-dark.svg';
export { ReactComponent as SingleForward } from './singleForward.svg';
export { ReactComponent as SingleForward2 } from './forward-new.svg';
export { ReactComponent as Playbtn } from './playbtn.svg';
export { ReactComponent as Playbtn2 } from './playbtn2.svg';
export { ReactComponent as VideoIcon } from './videoicon.svg';
export { ReactComponent as VideoIcon3 } from './videoicon2.svg';
export { ReactComponent as AttachmentCamera } from './file-camera.svg';
export { ReactComponent as AttachmentDoc } from './file-document.svg';
export { ReactComponent as AttachmentImageVideo } from './file-image.svg';
export { ReactComponent as AttachMusic } from './file-headset.svg';
export { ReactComponent as AttachVideo } from './file-video.svg';
// Message Dropdown option Icons start
export { ReactComponent as DeleteMessage } from './Frame (23).svg';
export { ReactComponent as Forward } from './Frame (22).svg';
export { ReactComponent as MessageInfo } from './messageinfo.svg';
export { ReactComponent as Reply } from '../images/new-images/reply.svg';
export { ReactComponent as Star } from '../images/new-images/starred.svg';
export { ReactComponent as Starred } from '../images/new-images/starred.svg';
export { ReactComponent as UnStar } from '../images/new-images/unstar.svg';
export { ReactComponent as StarredDark } from '../images/new-images/starred.svg';
export { ReactComponent as UnStarDark } from '../images/new-images/unstar.svg';
export { ReactComponent as Translate } from './translate.svg';
// Message Dropdown option Icons end
// File Types Icons start
export { default as Excel } from './media-types/excel.svg';
export { default as Pdf } from './media-types/pdf.svg';
export { default as Ppt } from './media-types/ppt.svg';
export { default as Placeholder } from './media-types/placeholder.svg';
export { default as Txt } from './media-types/txt.svg';
export { default as Word } from './media-types/word.svg';
export { default as Rar } from './media-types/rar.svg';
export { default as Zip } from './media-types/Zip.svg';
export { default as Csv } from './media-types/csv.svg';

// File Types Icons end

// Media Preview Icons

export { ReactComponent as PreviewClose } from './preview_close.svg';
export { ReactComponent as PreviewDownload } from './preview_download.svg';
export { ReactComponent as PreviewForward } from './preview_forward.svg';
export { ReactComponent as PreviewStar } from './preview_star.svg';
export { ReactComponent as PreviewStarActive } from './preview_star_active.svg';
export { ReactComponent as DropDownload } from './Frame (24).svg';
export { ReactComponent as PreviewChat } from './preview_chat.svg';

// Media Preview Icons end

export { ReactComponent as SelectedForward } from './message-forward.svg';
export { ReactComponent as SelectedClose } from './selected-close.svg';
export { ReactComponent as ReplyAudio } from './reply-icons/reply-audio.svg';
export { ReactComponent as ReplyAudioRecorded } from './reply-icons/reply-audio-recorded.svg';
export { ReactComponent as ReplyDocument } from './reply-document.svg';
export { default as AudioMessage } from './reply-icons/audioMessage.svg';
export { default as ReplyCamera } from './reply-icons/reply-camera.svg';
export { ReactComponent as ReplyContact, } from './reply-icons/reply-contact.svg';
export { default as ReplyVideo } from './reply-icons/reply-video.svg';
export { ReactComponent as ReplyPlay } from './reply-icons/reply-play.svg';
export { ReactComponent as ChatAudioSenderIcon } from './audio_record.svg';
export { ReactComponent as ChatAudioReceiverIcon } from './chataudio.svg';
export { ReactComponent as ChatBubble } from './chatBubble.svg';
export { ReactComponent as FiletypePlaceholderSender } from './media-types/filetype-placeholder.svg';
export { ReactComponent as FiletypePlaceholderReceiver } from './media-types/filetype-placeholderReceiver.svg';
export { ReactComponent as Audio } from './audio.svg';
export { ReactComponent as Camera } from './camera.svg';
export { ReactComponent as CloseReply } from './close-reply.svg';
export { ReactComponent as Contact } from './contact-icon.svg';
export { ReactComponent as DocumentIcon } from './document.svg';
export { ReactComponent as Location } from './location-icon.svg';
export { ReactComponent as ReplyVcard } from './reply-vcard.svg';
export { ReactComponent as VideoIcon2 } from './video.svg';
export { default as ChatContactSample } from './sample-profile.svg';
export { ReactComponent as Reset } from './reset.svg';
export { ReactComponent as AudioCall } from './Frame (29).svg';
export { default as SampleGroupProfile } from './sample-group-profile.svg';
export { default as SampleChatProfile } from './sample-profile.svg';
export { ReactComponent as VideoCall } from './Frame.svg';
export { default as AttachAudio } from './attachAudio.png';
export { default as dragDrop } from './media-types/drag-drop.png';
export { ReactComponent as CloseMessageInfoDetails } from './closeMessageInfoDetails.svg';
export { ReactComponent as EmptyDeliver } from './emptyDeliver.svg';
export { default as ImgEmptyArchive } from './emptyArchive.png';
export { ReactComponent as IconEmptyArchive } from './emptyArchive.svg';
export { ReactComponent as OpenMessageInfoDetails } from './openMessageInfoDetails.svg';
export { ReactComponent as CloseMessageInfo } from './closeMessageInfo.svg';
export { ReactComponent as CreateGroup } from './createGroup.svg';
export { ReactComponent as EditCamera } from './editcamera.svg';
export { ReactComponent as Remove } from './remove.svg';
export { default as GroupProfile } from './sample-group-profile.svg';
export { ReactComponent as Takephoto } from '../images/new-images/takephoto.svg';
export { ReactComponent as Upload } from '../images/new-images/upload.svg';
export { ReactComponent as Upload2 } from './upload2.svg';
export { ReactComponent as Upload3 } from './uploading2.svg';
export { ReactComponent as Viewphoto } from './view.svg';
export { ReactComponent as BlockedInfo } from '../images/new-images/msginfo.svg';
export { default as SampleProfile } from './sample-profile.svg';
export { ReactComponent as Rechatchatimage } from './new-images/start-chart.svg';
export { ReactComponent as Nochat } from './nochat.svg';
export { ReactComponent as AudioOnGoingCall } from './incoming-calls.svg';
export { ReactComponent as OnGoingCall } from './onGoingCall.svg';
export { ReactComponent as RecentCallHangup } from './webcall/recent-call-hangup.svg';
export { ReactComponent as RecentCallMute } from './webcall/recent-call-mute.svg';
export { ReactComponent as RecentCallMuteActive } from './webcall/recent-call-mute-active.svg';
export { ReactComponent as RecentVideoCall } from './webcall/recent-call-video.svg';
export { ReactComponent as RecentAudioCall } from './webcall/recent-call-audio.svg';
export { ReactComponent as RecentDeletedMessage } from './recent_deleted.svg';
export { ReactComponent as TileView } from './webcall/tileView.svg';
export { ReactComponent as EmptyCallLog } from './webcall/empty-calllog.svg';
export { ReactComponent as TileViewRemove } from './webcall/tileViewRemove.svg';
export { ReactComponent as IconIncoming } from './webcall/webcall-incoming.svg';
export { ReactComponent as IconOutgoing } from './webcall/webcall-outgoing.svg';
export { ReactComponent as IconIncomingMissed } from './webcall/missedcall-incoming.svg';
export { ReactComponent as IconAudiocall } from './webcall/webcall-audio.svg';
export { ReactComponent as IconVideocall } from './webcall/webcall-video.svg';
export { ReactComponent as IconPin } from './webcall/pin.svg';
export { ReactComponent as IconPinActive } from './webcall/pin-active.svg';
export { default as ImgBgCallEnd } from "./webcall/bg-call-end.svg";
export { default as SampleProfile1 } from './sarah.png';
export { default as Sarah1 } from './sarah.png';
export { default as SampleProfile2 } from './sarah1.jpg';
export { ReactComponent as StarBlue } from './star-blue.svg';
export { ReactComponent as StarGray } from './star-gray.svg';
export { default as SampleImage } from './seleced-files-1.png';
export { ReactComponent as InfoIcon } from '../images/new-images/msginfo.svg';
export { ReactComponent as EmptySearch } from './new-images/emptySearch.svg';
export { ReactComponent as EventWaiting } from "./loader.svg";
export { ReactComponent as MediaDownload } from './media-download.svg';
export { ReactComponent as MediaDownloadLite } from './media-download-lite.svg';
export { ReactComponent as NoMedia } from './no-media.svg';
export { ReactComponent as AudioPermissionIcon } from './new-images/audioPermission.svg';
export { ReactComponent as ClearChat } from './clearChat.svg'
export { ReactComponent as FileLoaderCircle } from './file-loader-close.svg';

export { ReactComponent as Fileloader } from './file-loader.svg';
export { ReactComponent as IconUploading } from './uploading.svg';
export { ReactComponent as IconSendingFailed } from './sendingFailed.svg';
export { ReactComponent as IconBackArrow } from './back-arrow.svg';
export { ReactComponent as IconScroltToDown } from './scrol-to-down.svg';
export { ReactComponent as IconExitGroup } from './exitgroup.svg';
export { ReactComponent as IconInvite } from './invite.svg';
export { ReactComponent as IconParticiants } from './particiants.svg';
export { ReactComponent as IconStaredArrow } from './stared-arrow.svg';
export { ReactComponent as IconStaredMenu } from './optionmenu-new-white.svg';
export { ReactComponent as IconNoStaredMessage } from './noStaredMessage.svg';
export { ReactComponent as IconNoStar } from './noStar.svg';
export { ReactComponent as IconCopy } from './copy.svg';
export { ReactComponent as IconLink } from '../images/new-images/Frame (2).svg';
export { default as ImgPreview } from './preview_image.png';
export { ReactComponent as IconAudioIncommingCall } from './webcall/audioIncommingCall.svg';
export { ReactComponent as IconAudioMissedCall } from './webcall/audioMissedCall.svg';
export { ReactComponent as IconAudioOutgoingCall } from './webcall/audioOutgoingCall.svg';
export { ReactComponent as IconVideoOutgoingCall } from './webcall/VideoOutgoingCall.svg';
export { ReactComponent as IconVideoIncommingCall } from './webcall/videoIncommingCall.svg';
export { ReactComponent as IconVideoMissedCall } from './webcall/videoMissedCall.svg';
export { ReactComponent as IconInvalidLink } from './webcall/invalid-link.svg';
export { ReactComponent as IconEditProfile, default as ImgEditProfile } from './editProfile.svg';
export { ReactComponent as IconUserPlaceholder, default as ImgUserPlaceholder } from './user-placeholder.svg';
export { ReactComponent as BackToChatWhite } from './webcall/backToChatWhite.svg';
export { default as MeetingLogo } from '../images/new-images/DazApp.svg';
export { default as CallEndimg } from './call-end.png';
export { default as profile1 } from './profile1.png';
export { default as profile2 } from './profile2.png';
export { default as profile3 } from './profile3.png';
export { ReactComponent as CallEndicon } from './callEndicon.svg';
export { ReactComponent as Callendiconplain } from './call-ended.svg';
export { ReactComponent as IconVerifiyedAccount } from './verifiyed_account.svg';
export { ReactComponent as IconReport } from '../images/new-images/report.svg';
export { ReactComponent as IconGroupReport } from './group_report.svg';
export { ReactComponent as IconSingleReport } from './single_report.svg';
export { default as VideoPlaceholder } from '../videos/placeholder.mp4';
export { ReactComponent as Calendar } from './Frame (30).svg';
export { ReactComponent as IconCalendarTime } from './IconCalendarTime.svg';
export { ReactComponent as IconNetwork } from './IconNetwork.svg';

//Daz App
export { default as DazaLogoVector } from "../images/new-images/appicon.svg";
export { default as DazaAppLogo } from "./new-images/DazApp.svg";
export { ReactComponent as SheduleMeeting } from "./new-images/meetingIcon.svg";
export { ReactComponent as AttachmentImage } from './attachment-image.svg';


//OCTEC App
export const AppLogo = OctecAppLogo;
export { default as RetryIcon } from "../images/retry.svg";
export { default as DownloadFileIcon } from "../images/download_file.svg";

